// Mirrors abuss/server/brands.js — keep ids in sync.
export const BRANDS = {
    abuss:    { id: "abuss",    name: "ABuss",    color: "#fe0000", siteUrl: "https://abuss.ee",    contactEmail: "info@abuss.ee" },
    triobuss: { id: "triobuss", name: "TrioBuss", color: "#5d7a8a", siteUrl: "https://triobuss.ee", contactEmail: "info@triobuss.ee" },
};
export const DEFAULT_BRAND = "abuss";
export const getBrand = (id) => BRANDS[id] || BRANDS[DEFAULT_BRAND];

export function BrandBadge({ brand, style }) {
    const b = getBrand(brand);
    return (
        <span style={{
            display: 'inline-block', padding: '1px 6px', borderRadius: 4, fontSize: 11, fontWeight: 600,
            lineHeight: '16px', color: '#fff', background: b.color, whiteSpace: 'nowrap', ...style
        }}>{b.name}</span>
    );
}
